<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"><em>Hong Kong is a former British colony and – since 1997 – a special region of China, located in the South China Sea.</em></p>
<p class="indent-para"><em>Ethnic Chinese make up more than 93.6 per cent of the population of roughly 7.4 million. Expatriates account for 4.6 per cent, representing countries from all over the world.</em></p>
<p class="indent-para"><em>Hong Kong is a highly significant global financial centre. Its people enjoy some of the longest life expectancies and the highest national IQ estimate in the world. It is generally safe and peaceful.</em></p>
<p class="indent-para"><em>However, there has been significant political turmoil in recent years, marked by democratic reform protests, some of which have resulted in violence and mass arrests.</em></p>
<p class="indent-para"><em>There are many diverse and intriguing characters that have made their fortune – or are planning on it – in this vibrant city. As is often the case with those seeking the excitement of riches, some of them will do anything to get the results they want.</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?921765ee